import { createApp, ref, onMounted } from 'vue';

const app = createApp({
    setup() {
        const isShowNotice = ref(true)

        const toggleNotice = () => {
            isShowNotice.value = !isShowNotice.value
            sessionStorage.setItem('NoticeShow',isShowNotice.value)
        }
        return { isShowNotice, toggleNotice }
    }
})
if (document.getElementById('notice')) {
  app.mount('#notice')
}